import {createClient} from '@supabase/supabase-js';

const SUPABASE_URL='https://pzwqyfparwpbubalnylu.supabase.co';
const SUPABASE_ANON_KEY=import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB6d3F5ZnBhcndwYnViYWxueWx1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA3NTkxMjEsImV4cCI6MjA4NjMzNTEyMX0.kQh6NcmB0Bxd1vmfzvfNj5sx9MQpA5tdWLjxg3pq4S8';

export const supabase=createClient(SUPABASE_URL,SUPABASE_ANON_KEY,{
  auth: {persistSession: true,autoRefreshToken: true}
});

export default supabase;